import { HelpContent } from '../../../../UI-Lib/Help-Tooltip';

export const AMEND_RETURNS_HELP: HelpContent[] = [
    {
        helpContentId: 'amend-returns.header',
        tooltipText: 'Create a batch to amend the selected returns.',
        hasIcon: true
    }
];
